
import { useNavigate, useParams,Navigate } from 'react-router-dom'; // For navigation
import React, { useState, useEffect} from "react";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const GameLoader = ()=>{
    const navigate = useNavigate();
    let {id} = useParams();
    const goHome = () => {
    navigate('/'); // Navigate to the home page
  };

const [redirect, setRedirect] = useState(false);
const [msisdn, setMsisdn] = useState("");
const [loading, setLoading] = useState(true);
const [error, setError] = useState("");
const [accessToken, setAccessToken] = useState("");
const [scienAccessToken, setScienAccessToken] = useState("");
const [cgUrl, setCgUrl] = useState("");
const [cgRedirect, setCgRedirect] = useState(false);
const [sourceIP, setSourceIP] = useState("");
// eslint-disable-next-line no-undef
const [ip, setIp] = useState("");
const userAgent = navigator.userAgent; // Get User-Agent
 

  useEffect(() => {
    const fetchMaskedMsisdn = async () => {
      try {

        console.log("Get Token.....");
        const {data} = await axios.get(`safaricomHeAccessToken/1`);
        setAccessToken(data.access_token);
        setSourceIP(data.source_ip);
        console.log("AT: ",data.access_token + ": source: " + data.source_ip);

        console.log("Go Saffing....");
        const response = await axios.get(
          "https://identity.safaricom.com/partner/api/v2/fetchMaskedMsisdn",
          
          {
            headers: {
              Authorization: `Bearer ${data.access_token}`,
              "X-App": "he-partner",
              "X-MessageID": "1234",
              "X-Source-System": "he-partner",
            },
            withCredentials: false, //
          }
        );

        const responseData = response.data.ServiceResponse;
        if (responseData.ResponseHeader.ResponseCode === "200") {
          setMsisdn(responseData.ResponseBody.Response.Msisdn);
        //  toast.success("Access Granted ✅", { position: "top-right" });
          //todo post msisdn to backend + the game
          await postMsisdnToBackend(responseData.ResponseBody.Response.Msisdn);
          const scienToken = await getNewAccessToken();
          console.log("SCIEN: " + scienToken)

          const redirectUrl = await getRedirectUrl(scienToken, responseData.ResponseBody.Response.Msisdn,data.source_ip);
          console.log("Final Redirect URL:", redirectUrl);
          
        } else {
          setError(responseData.ResponseHeader.ResponseMsg || "Unknown error");
          console.log(responseData.ResponseHeader.ResponseMsg);
        }
      } catch (err) {
        if (err.response && err.response.status === 403) {
          toast.error("Access Denied ❌", { position: "top-right" });
          //todo send user to info page for safaricom data then redirect them to home page
          setRedirect(true);
        } else if (err.message.includes("CORS")) {
          toast.error("Access Denied ❌ (CORS Error)", { position: "top-right" });
        } else {
          setError("Failed to fetch data. Please try again.");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchMaskedMsisdn();
  }, []);

  useEffect(() => {
    // Fetch the current IP address
    fetch("https://api64.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => setIp(data.ip))
      .catch((error) => console.error("Error fetching IP:", error));
  }, []);

  const generateRandomString = (length = 10) => {
    const characters = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz123456789"; // Excludes 0 and O
    let result = "";
    const randomValues = new Uint8Array(length);
    window.crypto.getRandomValues(randomValues);
  
    for (let i = 0; i < length; i++) {
      result += characters[randomValues[i] % characters.length];
    }
  
    return result;
  };

const postMsisdnToBackend = async (msisdn) => {
  console.log("Posting MSISDN to backend...");
  await axios.post("gameAccessData", { 
    msisdn,
    game_id:id,
   });

   //alert("MSISDN:" + msisdn)
};

const getNewAccessToken = async () => {
  console.log("Fetching new access token...");
  const { data } = await axios.get(`scienLabsAccessToken/1`);
  setScienAccessToken(data.access_token);
  //alert("Scien Access: " + data.token)
  return data.access_token;
  
};

const getRedirectUrl = async (token, dMsisdn,ipAddress) => {

  console.log("Getting redirect URL..." + token + "... Ends Token");
  
  const { data } = await axios.post(
    "scienRedirect",
    { 
      msisdn:dMsisdn,
      campaign_id:"67e0e22949ffff7516d3f969",
      source_ip:ipAddress,
      requestid:generateRandomString(10),
      redirect_url :"https://app.bongagames.co.ke/#/gameLoader/"+id,
      user_agent:userAgent,
      access_token: token,
}, // Request body
    {
      headers: {
        Authorization: `Bearer ${token}`, // Set the Bearer token here
        "Content-Type": "application/json", // Ensure JSON format
      },
      withCredentials: false, //
    }
  );
  if(data.responseCode === 200 ){
    setCgUrl(data.cg_url);
    setCgRedirect(true);
  }

  return data.cg_url;
};

  if(redirect){
    return <Navigate to={'/noSafData'} />
}

if(cgRedirect){
  window.location.href=cgUrl;
}
   
    return (
        <>
          {/* <div className="p-4">
      {loading && <p className="text-blue-500">Loading...</p>}
      {error && <p className="text-red-500">{error}</p>}
      {msisdn && <p className="text-green-500">Masked MSISDN: {msisdn}</p>}
    </div> */}
         <div className="relative bg-gray-900 h-screen w-screen">
      {/* Floating Home Button */}
      <button
        onClick={goHome}
        className="absolute top-4 right-4 flex items-center space-x-2 bg-gray-800 text-gray-300 p-2 rounded-lg shadow hover:text-white hover:bg-gray-700"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3 12l9-9m0 0l9 9m-9-9v18"
          />
        </svg>
        <span className="hidden md:inline text-sm font-medium">Home</span>
      </button>

      {/* Fullscreen Iframe */}
      <iframe
        src={`/games/${id}/index.html`}
        title="Game"
        className="w-full h-full"
      />
    </div>
  

        </>
         );
};
export default GameLoader;